import { render, staticRenderFns } from "./fbDetail.vue?vue&type=template&id=51615fde&scoped=true&"
import script from "./fbDetail.vue?vue&type=script&lang=js&"
export * from "./fbDetail.vue?vue&type=script&lang=js&"
import style0 from "./fbDetail.vue?vue&type=style&index=0&id=51615fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51615fde",
  null
  
)

export default component.exports